import CcConstantAdmin from './src/views/cc-constant-admin.vue'
import CcConstantLabel from './src/components/cc-constant-label-js.js'
import CcConstantSelector from './src/components/cc-constant-selector-js.js'
import cache from './src/cache.js';

const components = [
    CcConstantAdmin,
    CcConstantLabel,
    CcConstantSelector
]

const install = function (Vue) {
    if (install.installed) return
    components.forEach(component => {
        Vue.component(component.name, component)
    })

}

export default {
    install,
    cache,
    CcConstantAdmin,
    CcConstantLabel,
    CcConstantSelector
}
